import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService, HomeAssistantResponse } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

import { FormBuilder, FormGroup } from '@angular/forms'; // Import FormGroup and FormBuilder

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
   // Define FormGroup
   searchForm: FormGroup;

  showloading: boolean = true;
  notfound: boolean = false;
  bookingId: string = "";
  isLoading = false;
  bookingDetails: any;
  showComponent: boolean = false;
  errorMessage: string = "";
  aiMessage = '';
  aiReply = '';
  aiError = '';
  aiLoading = false;
  aiSpecialtyId: number | null = null;
  aiSpecialty = '';
  aiDate: string | null = null;
  aiTimeOfDay: string | null = null;

  accessToken:any;

  selectedBranchId:any;
  allBranches: any;
  branches:any;
  loading: boolean = true;

  constructor(private router: Router, private apiService: ApiService, private storage: StorageService,  private spinner: NgxSpinnerService, private formBuilder: FormBuilder) { 
      // Initialize FormGroup in constructor
      this.searchForm = this.formBuilder.group({
        branches: [''], // Initialize form control names here
        specialities: [''],
        // Example, add more as needed
        doctorName: [''],
      });
  }

 // Api call for getting hospital all branches
 getHospitals(){
  this.apiService.getAllHospitals().subscribe((response: any) => {
    if (response.status === "success") {
      // this.branches = response.data.data.slice(0, 4);
      this.allBranches = response.data.data;
      this.loading = false;
    } 
  });
}


  // Event for getting branch id
  onBranchSelectionChange(selectedBranchId: number | string) {
    // Assign selectedBranchId to any variable or perform further actions
    this.selectedBranchId = selectedBranchId;
  }

  askBookingAssistant(): void {
    const message = this.aiMessage.trim();
    if (!message || this.aiLoading) {
      return;
    }

    this.aiLoading = true;
    this.aiReply = '';
    this.aiError = '';
    this.aiSpecialtyId = null;
    this.aiSpecialty = '';
    this.aiDate = null;
    this.aiTimeOfDay = null;

    this.apiService.homeBookingAssistant(message).subscribe({
      next: (response: HomeAssistantResponse) => {
        this.aiLoading = false;
        if (!response.success || !response.data) {
          this.aiError = response.message || 'I could not understand that appointment request.';
          return;
        }

        this.aiReply = response.data.reply;
        this.aiSpecialtyId = response.data.specialty_id;
        this.aiSpecialty = response.data.specialty || '';
        this.aiDate = response.data.appointment_date;
        this.aiTimeOfDay = response.data.time_of_day;
      },
      error: (error: any) => {
        this.aiLoading = false;
        this.aiError = error?.error?.message || 'The booking assistant is temporarily unavailable.';
      }
    });
  }

  continueToDoctors(): void {
    if (!this.selectedBranchId) {
      this.aiError = 'Please select a hospital before continuing.';
      return;
    }

    this.router.navigate(['/doctors', {
      branchId: this.selectedBranchId,
      ...(this.aiSpecialtyId ? { specialtyId: this.aiSpecialtyId } : {})
    }]);
  }

  ngOnInit(): void {

    this.getHospitals();
  }
}
